import api from "./axios";
import { detectPersona } from "../lib/detectPersona";

// T203: every /start/ call carries persona_hint (detected from path)
// + optional nps_score. _withPersona is a tiny wrapper that injects
// the persona at the API boundary so call sites don't repeat the
// detect call. Server clamps both fields.
function _withPersona(body, opts = {}) {
  return {
    ...body,
    persona_hint: opts.persona_hint ?? detectPersona(body.page_path),
    ...(opts.nps_score != null ? { nps_score: opts.nps_score } : {}),
  };
}

export const startFeedback = (message, page_path, opts = {}) =>
  api.post("/api/feedback/start/", _withPersona({ message, page_path }, opts));

export const replyFeedback = (threadId, message) =>
  api.post(`/api/feedback/${threadId}/reply/`, { message });

export const closeFeedback = (threadId) =>
  api.post(`/api/feedback/${threadId}/close/`);

export const getFeedbackThread = (threadId) =>
  api.get(`/api/feedback/${threadId}/`);

export const getMyFeedback = () => api.get("/api/feedback/mine/");

// Multipart upload of an annotated screenshot. No thread required —
// returns {s3_key, url}. Caller passes s3_key in the next message body.
export const uploadFeedbackImage = (blob) => {
  const fd = new FormData();
  fd.append("image", blob, "feedback.png");
  return api.post("/api/feedback/upload-image/", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// startFeedback / replyFeedback now optionally take an s3_key
export const startFeedbackWithImage = (message, page_path, image_s3_key, opts = {}) =>
  api.post(
    "/api/feedback/start/",
    _withPersona({ message, page_path, image_s3_key }, opts),
  );

// T203: NPS-prompt origin. Server tags nps_score on the thread.
// Use this when the operator submits a 0-10 rating; message can be
// the optional follow-up comment ("why this score?").
export const startNpsFeedback = (score, message = "", page_path = "") =>
  api.post(
    "/api/feedback/start/",
    _withPersona({ message: message || `NPS: ${score}/10`, page_path }, { nps_score: score }),
  );

export const replyFeedbackWithImage = (threadId, message, image_s3_key) =>
  api.post(`/api/feedback/${threadId}/reply/`, { message, image_s3_key });
